//index.html
import './components/banner';
import './components/burger';
import './components/offers';
import './components/useful';
import './components/tooltip';
import './components/choices';
import './components/just-validate.min';
import './components/inputmask.min';
import './components/validate-form';

//catalog
import './components/nouislider.min.js';
import './components/range-slider';
import './components/catalog/schow-more';
import './components/catalog/select';


